import { $authHost, $host, $host_sms } from './index'
import jwt_decode from 'jwt-decode'

export const registration = async (phone, password, role) => {
  const { data } = await $host.post('api/auth/register', {
    phone,
    password,
  })
  localStorage.setItem('token', data.token)
  return jwt_decode(data.token)
}

export const login = async (phone, password) => {
  const { data } = await $host.post('api/auth/login', { phone, password })
  localStorage.setItem('token', data.token)
  return jwt_decode(data.token)
}

export const check = async () => {
  const { data } = await $authHost.get('api/auth/check')
  localStorage.setItem('token', data.token)
  return jwt_decode(data.token)
}

export const addCode = async (phone, code) => {
  const { data } = await $host.post('api/user/code/add', { phone, code })
  return data.codeRes.code
}

export const getCode = async (phone, code) => {
  const { data } = await $host.post('api/user/code/get', { phone, code })
  console.log(data)
  return data.user.code
}

export const checkCode = async (phone, code) => {
  // SMS-шлюз (uley_mango) — используем $host_sms (REACT_APP_WEBAPP_SMS),
  // не $host_call (REACT_APP_WEBAPP_CALL — для звонков /calls/*, см. adminAPI.js).
  const { data } = await $host_sms.post('/sms/send', { to_number: phone, code: `${code}` })
  console.log(data)
  return data.code
}

export const addCodeDev = async (phone) => {
  const { data } = await $host.post('api/user/code/add-dev', { phone })
  console.log(`📱 Код подтверждения для ${phone}: ${data.code}`)
  return data.code
}
